import { aboutContent } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-3">{aboutContent.title}</h2>
          <p className="text-sm md:text-base text-foreground-600">国内领先的耽美漫画在线阅读平台</p>
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-8">{aboutContent.description}</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {aboutContent.features.map((feature) => (
              <div key={feature} className="flex items-center gap-2 bg-background-50 rounded-lg px-4 py-3 border border-background-200/60">
                <i className="ri-check-line text-primary-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                <span className="text-sm text-foreground-700 font-medium">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}